import *as React from 'react'

import {AppContext} from "../../../Context/AppContext"

import "./style.scss"

export function PageSelector() {

    const {setPage,page,role, siteList} = React.useContext(AppContext)

    return (
        <div className="page-selector">
            {/* createSite */}
            {role=="SuperAdmin"&&<button className={ page === "client" ? "selected" : "" } onClick={() => { setPage("client") } }>Création des clients</button>}
            {<button className={page === "client-info" ? "selected" : ""} onClick={()=>{setPage("client-info")}}>Informations client</button>}
            {(role=="SuperAdmin"||role=="Admin")&&<button className={page=="createSite"?"selected":""} onClick={()=>{setPage("createSite")}}>Création site</button>}
            {siteList.length > 0 && <button className={page=="site"?"selected":""} onClick={()=>{setPage("site")}}>Gestion informations du site</button>}
            {siteList.length > 0 &&<button className={page=="horaires"?"selected":""} onClick={()=>{setPage("horaires")}}>Gestion horaires</button>}
            {siteList.length > 0 &&<button className={page=="mesures"?"selected":""} onClick={()=>{setPage("mesures")}}>Gestion mesures</button>}
            {siteList.length > 0 &&<button className={page=="events"?"selected":""} onClick={()=>{setPage("events")}}>Gestion des évènements</button>}
            {siteList.length > 0 &&<button className={page=="flow"?"selected":""} onClick={()=>{setPage("flow")}}>Gestion Coefficients</button>}
            {role=="SuperAdmin"&&<button className={ page === "userapp" ? "selected" : "" } onClick={() => { setPage("userapp") } }>Affectation des droits</button>}
          {/*  {role=="SuperAdmin"&&<button className={ page === "smartvision" ? "selected" : "" } onClick={() => { setPage("smartvision") } }>SmartVision</button>} */}

        </div>
    )
}
